// extracted by mini-css-extract-plugin
module.exports = {"productItemClassName":"MainProductsGrid_productItemClassName__eO1dL","youMayAlsoLikeClassName":"MainProductsGrid_youMayAlsoLikeClassName__LgSYx"};